import InmuebleEdoCuentaTemplate from "../../components/templates/inmuebles/InmuebleEdoCuentaTemplate";

const InmuebleEdoCuenta = () => {
    return <InmuebleEdoCuentaTemplate/>;
};

export default InmuebleEdoCuenta;